export const SOCIAL_LINKS = ['LinkedIn', 'GitHub'];
